import { useMutation } from '@tanstack/react-query';
import {
  type SaveEventAttendanceInput,
  gqlClient,
  graphql,
  queryClient,
} from '@tyro/api';
import { groupsKeys } from '@tyro/groups';
import { attendanceKeys } from './keys';

const saveAttendance = graphql(/* GraphQL */ `
  mutation attendance_saveEventAttendance($input: [SaveEventAttendanceInput]) {
    attendance_saveEventAttendance(input: $input) {
      id
      eventId
      attendanceCodeId
      personPartyId
      date
    }
  }
`);

export function useSaveAttendance() {
  return useMutation({
    mutationFn: (input: SaveEventAttendanceInput[]) =>
      gqlClient.request(saveAttendance, { input }),
    onSuccess: async () => {
      await Promise.all([
        queryClient.invalidateQueries({ queryKey: attendanceKeys.all }),
        queryClient.invalidateQueries({
          queryKey: groupsKeys.subject.allLessons(),
        }),
      ]);
    },
  });
}
